export const TOGGLE_EXPAND_MENU = 'TOGGLE_EXPAND_MENU',
      CATCH_API_ERROR = 'CATCH_API_ERROR',
      //
      PROFILE_REQUEST = 'PROFILE_REQUEST',
      PROJECT_INFO_REQUEST = 'PROJECT_INFO_REQUEST',
      PROJECT_INFO_REQUEST_SUCCESS = 'PROJECT_INFO_REQUEST_SUCCESS',
      SET_TOKEN = 'SET_TOKEN',
      //
      ACTIVATE_ORGANISATION = 'ACTIVATE_ORGANISATION',
      SELECT_AGENT = 'SELECT_AGENT',

      ON_NAVIGATE = 'ON_NAVIGATE',
      //
      LOGOUT_AUTH = 'LOGOUT_AUTH',
      //
      GENERAL_SOCKET_INFO_REQUEST = 'GENERAL_SOCKET_INFO_REQUEST',
      CONNECTING = 'CONNECTING',
      CONNECT = 'CONNECT',
      AUTH_CHECK_SESSION = 'AUTH_CHECK_SESSION',
      SOCKET_RECONNECTION_ERROR = 'SOCKET_RECONNECTION_ERROR',
      INIT_DATA = 'INIT_DATA'

